import React from 'react';
import { Grid, ListItem, Paper, Tooltip, makeStyles } from "@material-ui/core"
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CreateIcon from '@material-ui/icons/Create';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { UtilsDate } from '../../../../app/orussystem/utils/UtilDate';
import { ROL_USER } from '../../../../app/api-client/constants';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: "flex",
  },
  spreadBox: {
    justifyContent: "space-between",
    alignItems: "center"
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: "0 auto",
    textAlign: "center",
    alignItems: "center"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paperModal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  paperContent: {
    backgroundColor: process.env.REACT_APP_PRIMARY_THEMA,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 1),
    borderRadius: '10px'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-3%',
    marginBottom: '3.2%'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export const ListUbicaciones = ({ rows, openModalEdit, classes, changeStatus, isLoanding }) => {
  const clases = useStyles()

  const rol = localStorage.getItem(ROL_USER);
  const r = rows !== undefined && rows !== null ? rows : []
  const validateRowsTable = (item) => {

    if (item !== undefined && item !== null) {
      return item
    } else {
      return "---"
    }

  }

  return (

    <>
      {r.map((row) => (

        <Paper key={row.id} className={clases.card}>
          <Grid container spacing={1}>
            <Grid  style={{ width: '20.5%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.value)}
            </Grid>
            <Grid  style={{ width: '22%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.key)}
            </Grid>
            <Grid style={{ width: '10%', fontWeight: "bold", fontSize: '17px' }}>
              {validateRowsTable(row.status !== false ? 'Activo' : 'Inactivo')}
            </Grid>

            {/* {
              rol === "ROLE_ADMIN" ? */}
                <Grid style={{ width: '12%', fontWeight: "bold", fontSize: '17px' }}>
                  {validateRowsTable(row.cliente.nombre)}
                </Grid>
                {/* : <></>

            } */}
            <Grid item xs={2} style={{ width: '16%', fontWeight: "bold", fontSize: '17px' }}>
              {UtilsDate().formatDDMMMYYYYHHmm(new Date(row.updated))}
            </Grid>
            <Grid item xs={1} onClick={() => { openModalEdit(row) }} setId={row}>
              <ListItem button >
                <Tooltip title="Editar" aria-label="top-end">
                  <CreateIcon color="primary" style={{ marginLeft: '30%' }} />
                </Tooltip>
              </ListItem>
            </Grid>
            {rol === 'ROLE_ADMIN' && (
            <Grid item xs={1} onClick={() => { changeStatus(row) }}>
              <ListItem button >
                <Tooltip title={row.status ? "Inhabilitar" : "Habilitar"} aria-label="top-end">
                  {row.status === !"activo" ? <CheckCircleOutlineIcon color="primary" style={{ marginLeft: '30%' }} /> : <NotInterestedIcon color="primary" style={{ marginLeft: '30%' }} />}
                </Tooltip>
              </ListItem>
            </Grid>
            )}
          </Grid>
        </Paper>
      ))}


    </>
  )
}